/** Range input with a filled yellow track (CSS var --fill); 'tan' is the slimmer per-player variant. */
export function Slider({
  min,
  max,
  step = 1,
  value,
  onChange,
  variant = 'gradient',
  label,
  testId,
  marks,
}: {
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (v: number) => void;
  variant?: 'gradient' | 'tan';
  label: string;
  testId?: string;
  marks?: Array<{ value: number; label: string }>;
}) {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className={`slider slider-${variant}`}>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        aria-label={label}
        aria-valuetext={`${value}%`}
        data-testid={testId}
        style={{ ['--fill' as string]: `${pct}%` }}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      {marks ? (
        <div className="slider-marks" aria-hidden>
          {marks.map((m) => (
            <span key={m.value} style={{ left: `${((m.value - min) / (max - min)) * 100}%` }}>
              {m.label}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
}
